import {
   TemplateDetailsStatusEnum,
   useAccountStore,
   useContactTemplatesStore
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { GetContactTemplateBasicDetailsQuery as Query } from './query.generatedTypes'

const useAPIResponseHandler = (): ((response: Query) => void) => {
   const contactTemplatesStore = useContactTemplatesStore()
   const accountStore = useAccountStore()

   const handleAPIResponse = (
      response: Query,
      onSuccess?: (boardId: string) => void
   ) => {
      const userAppConfigData = response.getUserAppConfig
      if (!userAppConfigData) return
      const { contactTemplate } = userAppConfigData

      const hasTemplate = contactTemplatesStore.hasTemplate(
         userAppConfigData.contactTemplate.contactTemplateId
      )

      if (hasTemplate) return

      contactTemplatesStore.createOrUpdateTemplate({
         templateId: userAppConfigData.contactTemplate.contactTemplateId,
         name: userAppConfigData.contactTemplate.name,
         gofs: [],
         workflows: [],
         assigneeFieldsMapping: [],
         identificationFieldIds: []
      })

      contactTemplatesStore
         .getTemplate(contactTemplate.contactTemplateId)
         .setTemplateDetailsStatus(TemplateDetailsStatusEnum.InCompleteDetails)

      accountStore.setContactTemplateId(contactTemplate.contactTemplateId)
   }

   return handleAPIResponse
}

export default useAPIResponseHandler
